import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Redirect, Route } from "react-router-dom";
import { USER_ROLES } from "../Constants";

export const VSourceRoute = (props) => {
    const { component: Component, ...rest } = props;
    const { context, userHavePermission } = useContext(AuthContext);

    const isVSourceUser = userHavePermission(
        { user: context.user },
        USER_ROLES.VSOURCE_CLIENT_USER
    );

    return (
        <Route
            {...rest}
            render={(props) =>
                isVSourceUser ? (
                    <Component {...props} {...rest} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/dashboard",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};
